/**
 * Simple Logger Utility
 *
 * Creates a namespaced logger that prefixes all messages with [namespace].
 * In production, debug-level logs are suppressed unless explicitly enabled.
 */

export interface Logger {
  debug: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
}

const isProduction = typeof process !== 'undefined' && process.env?.NODE_ENV === 'production';

export function createLogger(namespace: string): Logger {
  const prefix = `[${namespace}]`;
  return {
    debug: isProduction ? () => {} : (...args: unknown[]) => console.log(prefix, ...args),
    info: (...args: unknown[]) => console.info(prefix, ...args),
    warn: (...args: unknown[]) => console.warn(prefix, ...args),
    error: (...args: unknown[]) => console.error(prefix, ...args),
  };
}
